import {Pipe, PipeTransform} from '@angular/core';
import {UserService} from '../services/user.service';

@Pipe({
  name: 'userName'
})
export class UserNamePipe implements PipeTransform {
  constructor(private userService: UserService) {}

  transform(id: number): any {
    const users = this.userService.getUser();
    const Fname = (users.filter(user => user.id === id)[0].first_name).toUpperCase();
    const last_name = (users.filter(user => user.id === id)[0].last_name).toUpperCase();
    const first_name = Fname.replace(/ /g, '');
    const full_name = last_name + '/' + first_name;
    return full_name;
  }
}
